import {SerpListingsUpdatedEvent} from "../../../../common/ts/events/Events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import SimilarToClickListingsService from "../services/SimilarToClickListingsService";

export default class SimilarToClickListingsSubscriber {
    private eventBus: EventBus;
    private similarToClickListingsService: SimilarToClickListingsService;
    private clickedListingIds: Set<string>;
    private subscribedListingIds: Set<string>;

    constructor(
        eventBus: EventBus,
        similarToClickListingsService: SimilarToClickListingsService,
    ) {
        this.eventBus = eventBus;
        this.similarToClickListingsService = similarToClickListingsService;
        this.clickedListingIds = new Set<string>();
        this.subscribedListingIds = new Set<string>();
    }

    init() {
        this.subscribeToListingClicks();

        this.eventBus.subscribeWithId(SerpListingsUpdatedEvent.TYPE, {
            id: 'nestoria-serp-listings-updated-similar-to-click-subscriber',
            callback: () => {
                this.subscribeToListingClicks();
            }
        });
    }

    private subscribeToListingClicks() {
        document.querySelectorAll('.js-property-cta')
            .forEach((element: Element) => {
                const listing = element.closest('.snippet-listing');
                if (!listing) return;

                const listingId = listing.getAttribute('data-id') || '';
                if (this.subscribedListingIds.has(listingId)) return;

                element.addEventListener('click', () => {
                    this.onListingClick(listing, listingId);
                });
                this.subscribedListingIds.add(listingId);
            });
    }

    private onListingClick(listing: Element, listingId: string) {
        if (!this.clickedListingIds.has(listingId)) {
            this.clickedListingIds.add(listingId);

            const geoId = listing.getAttribute('data-geo-id') || '';
            const operationType = listing.getAttribute('data-operation-type') || '';
            const bedroomsAttr = listing.getAttribute('data-bedrooms');
            const bathroomsAttr = listing.getAttribute('data-bathrooms');
            const priceAttr = listing.getAttribute('data-price');
            const pageViewId = document.querySelector('[data-page-view-id]')?.getAttribute('data-page-view-id') || '';
            const excludeListings = this.getAllListingIds();

            this.similarToClickListingsService.execute({
                listingId: listingId,
                geoId: geoId,
                operationType: operationType,
                bedrooms: bedroomsAttr ? parseInt(bedroomsAttr, 10) : null,
                bathrooms: bathroomsAttr ? parseInt(bathroomsAttr, 10) : null,
                price: priceAttr ? parseFloat(priceAttr) : null,
                listing: listing,
                pageViewId: pageViewId,
                excludeListings: excludeListings,
            });
        }
    }

    private getAllListingIds(): string[] {
        const listingIds: string[] = [];
        document.querySelectorAll('.snippet-listing').forEach((listing: Element) => {
            const id = listing.getAttribute('data-id');
            if (id) {
                listingIds.push(id);
            }
        });
        return listingIds;
    }
}
